import axios from '../axios';
import { buildProjectDocumentationPayload } from '../utils/projectDocumentationBuilder.ts';
import { projectDocumentationService } from './projectDocumentationService.ts';

const getAuthHeaders = () => {
  const authToken = localStorage.getItem("access-Token-Edify");
  return { headers: { Authorization: `Bearer ${authToken}` } };
};

export const mercadoPagoOAuthService = {
  exchangeCodeForToken: async (code: string, codeVerifier: string) => {
    try {
      const response = await axios.post('/user/merchant-account/create', {
        code,
        code_verifier: codeVerifier
      }, getAuthHeaders());
      return response.data;
    } catch (error) {
      console.error('Error exchanging OAuth code for token:', error);
      throw error;
    }
  },

  createProjectDocumentation: async (formData: any, fileItems: any[], additionalData: any, userId?: string | number, onProgress?: (current: number, total: number) => void) => {
    try {
      let finalUserId = userId;
      
      if (!finalUserId) {
        try {
          const state = JSON.parse(localStorage.getItem('persist:general') || '{}');
          const generalState = JSON.parse(state.general || '{}');
          finalUserId = generalState.userData?.id;
        } catch (e) {
          console.error('Error getting user data from state:', e);
        }
      }
      
      if (!finalUserId) {
        throw new Error('No se pudo obtener el ID del usuario');
      }
      
      const payload = buildProjectDocumentationPayload(formData, additionalData, false, finalUserId);
      
      const createResponse = await projectDocumentationService.createProjectDocumentationComplete(payload, fileItems, onProgress);

      return createResponse;
    } catch (error) {
      console.error('Error creating project documentation:', error);
      throw error;
    }
  }
};
